module.exports = __webpack_public_path__ + "static/media/icon-piece5-2.2cfa4117.png";